import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { selectors as featuresSelectors } from 'features';
import { route as routePropType } from 'common/propTypes';
import { getAuthServiceUrl } from 'auth/utils/getAuthServiceUrl';
import { UO_signUpRoute } from 'app/containers/routes';
import NotFound from 'common/components/NotFound';
import PrivateRoute from 'app/containers/PrivateRoute';
import PublicRoute from 'app/containers/PublicRoute';
import SignUpPage from './SignUp';
import SetPasswordPage from './SetPassword';
import GetStartedPage from './GetStarted';

const SignUpEntry = ({ isSSOActive, sandboxMode }) => {
  useEffect(() => {
    if (!isSSOActive) return;

    const authServiceUrl = getAuthServiceUrl();
    window.location = `${authServiceUrl}${UO_signUpRoute}`;
  }, [isSSOActive]);

  if (isSSOActive) return null;

  return <SignUpPage sandboxMode={sandboxMode} />;
};

SignUpEntry.propTypes = {
  isSSOActive: PropTypes.bool.isRequired,
  sandboxMode: PropTypes.bool,
};

const Routes = ({
  isMerchantRegistrationActive,
  match,
  sandboxMode,
  isSSOActive,
}) => {
  const canShowSignUp = isMerchantRegistrationActive;

  return (
    <Switch>
      <PrivateRoute
        path={`${match.path}/get-started`}
        component={GetStartedPage}
        exact
      />
      {canShowSignUp && (
        <PublicRoute
          path={`${match.path}/sign-up`}
          component={SignUpEntry}
          sandboxMode={sandboxMode}
          isSSOActive={isSSOActive}
          exact
        />
      )}
      <PublicRoute
        path={`${match.path}/set_password`}
        component={SetPasswordPage}
        exact
      />
      <PublicRoute component={NotFound} />
    </Switch>
  );
};

Routes.propTypes = {
  ...routePropType,
  isMerchantRegistrationActive: PropTypes.bool.isRequired,
  sandboxMode: PropTypes.bool,
  isSSOActive: PropTypes.bool,
};
export default connect((state) => ({
  ...featuresSelectors.getOnboardingFlags(state),
  isSSOActive: featuresSelectors.isSSOActive(state),
}))(Routes);
